import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import { formatGameTime } from "../format/formatGameTime";
import { formatList } from "../format/formatList";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";

const TITLE = msg({
  id: "finding.multi_kill",
  message: "{count, plural, one {Multi-kill} other {# multi-kills}}",
});

const STREAK = msg({ id: "finding.multi_kill.streak", message: "{time}: {victims}" });

// Сильная сторона: серии убийств за считаные секунды.
export const MultiKill = ({ finding, variant }: FindingProps<"multi_kill">) => {
  const { i18n } = useLingui();
  const findHero = useAssetLookup("heroes");
  const { streaks } = finding.params;
  const details = streaks
    .map((streak) =>
      i18n._({
        ...STREAK,
        values: {
          time: formatGameTime(streak.time_s),
          victims: formatList(
            streak.victim_hero_ids.map((id) => findHero(id).name),
            i18n.locale,
          ),
        },
      }),
    )
    .join(". ");
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={
        <AssetIcon asset={findHero(streaks[0]?.victim_hero_ids[0] ?? 0)} size={iconSize(variant)} />
      }
      title={i18n._({ ...TITLE, values: { count: streaks.length } })}
      details={details}
      summary={details}
    />
  );
};
